export function InitialState() {
    return {
        fetchResponsesApi: {
            isProcessing: false,
            data:null,
            error:false,
            message:'',
        },
    };
}